import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Subject } from "rxjs/Subject";
import 'rxjs/add/operator/map';
import { timeout } from "rxjs/operator/timeout";


@Injectable()
export class VisitsService {
    http: Http;

    visitsDataChange = new Subject<void>();
    visits = [];
    private visitsData = [];



    constructor(http: Http) {
        this.http = http;
    }


    fetchVisitsCount(media) {
        this.http.get(`/api/visits-counts/${media}`)
            .map((response: Response) => {
                const data = response.json();
                this.visits = [
                    [
                        {
                            "meter1": data.hour.today,
                            "meter2": data.hour.lastweek,
                            "total": (data.hour.max < data.hour.today ? data.hour.today : data.hour.max * 1.05),
                            "min": data.hour.min,
                            "max": data.hour.max,
                            "media": (data.hour.min + data.hour.max) / 2,
                            "active": data.hour.active,
                            "moment": data.hour.at,
                            "momentPrev": data.hour.atMinus60
                        }
                    ],
                    [
                        {
                            "meter1": data.day.today,
                            "meter2": data.day.lastweek,
                            "total": (data.day.max < data.day.today ? data.day.today : data.day.max * 1.05),
                            "min": data.day.min,
                            "max": data.day.max,
                            "media": (data.day.min + data.day.max) / 2,
                            "active": data.day.active,
                            "moment": data.day.at,
                            "momentPrev": data.day.start
                        }
                    ]
                    // ,
                    // [
                    //     {
                    //         "meter1": data.last24h.today,
                    //         "meter2": data.last24h.lastweek,
                    //         "total": data.last24h.max * 1.1,
                    //         "min": data.last24h.min,
                    //         "max": data.last24h.max,
                    //         "media": (data.last24h.min + data.last24h.max) / 2
                    //     }
                    // ]
                ];


                return this.visits;
            })
            .subscribe(
            (data) => {
                this.visitsData = data;
                // console.log(data);
                setTimeout(() => this.visitsDataChange.next(), 1000 * 3);
            }
            );
    }
    fetchVisitsGuageHour() {
        return this.visitsData[0];
    }
    fetchVisitsGuageToday() {
        return this.visitsData[1];
    }

}


// WEBPACK FOOTER //
// /home/node/src/app/_services/visits.service.ts